module.exports = __webpack_public_path__ + "static/about_computer-951ab92988f558965a8536449044f8df.jpg";